export function createReviewHandlers({
  hostAdapter,
  lockTreeByReactionId,
  unlockTreeByReactionId,
}) {
  const handleReviewStateChanged = (detail) => {
    const parsed = hostAdapter.parseReviewStateChangedPayload(detail);
    if (!parsed) {
      return;
    }
    const { reactionId, state, isLocked } = parsed;
    hostAdapter.rememberReviewState(reactionId, state);
    if (isLocked) {
      lockTreeByReactionId(reactionId, state);
      return;
    }
    unlockTreeByReactionId(reactionId);
  };

  const handleReviewActionError = () => {
    // Reserved for host-side error reactions; currently no-op by design.
  };

  return {
    handleReviewStateChanged,
    handleReviewActionError,
  };
}
